import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { useXmlDaNota } from '@/services/Documentos';
import { baixarXmlDaNota } from './documentos-helpers';

interface BotaoBaixarXmlProps {
  chaveAcesso: string;
}

/**
 * "Baixar XML" no detalhe da nota (SPEC-018, §3, item 5): o XML do acervo do e-Malote, baixado na mesma aba. Quem
 * confere que a nota é do gestor é a API; a tela manda só a chave.
 */
export function BotaoBaixarXml({ chaveAcesso }: BotaoBaixarXmlProps) {
  const { toast } = useToast();
  const xmlDaNota = useXmlDaNota();

  const baixar = async () => {
    try {
      const resposta = await xmlDaNota.mutateAsync({ ChaveAcessoDOC: chaveAcesso });
      if (!resposta.status?.resultado || !resposta.data?.Xml) {
        throw new Error(resposta.status?.mensagem || 'Não foi possível obter o XML desta nota.');
      }
      baixarXmlDaNota(resposta.data.Xml, resposta.data.NomeArquivo || `${chaveAcesso}.xml`);
    } catch (erro) {
      toast({
        variant: 'destructive',
        title: 'Erro ao baixar XML',
        description:
          erro instanceof Error ? erro.message : 'Não foi possível baixar o XML desta nota.',
      });
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={baixar}
      disabled={xmlDaNota.isPending || !chaveAcesso}
    >
      {xmlDaNota.isPending ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Download className="h-4 w-4" />
      )}
      Baixar XML
    </Button>
  );
}
